import styled from '@emotion/styled'
import * as v from '../../../../../variables/styled'

export const AttachmentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.MuiCardContent-root': {
    paddingTop: '0px',
  }, 

  'button.hiddenButton': {
    color: 'transparent',
    background: 'transparent',
  },

  'button.hiddenButton:hover': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:focus': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:active': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },
})

export const AttachmentFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
})